import { FormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
// NgRx actions / selectors
import { createWatchlist, removeWatchlistItemError, setWatchlistItemError, } from 'WatchlistApp/ts/features/add-to-watchlist-modal/state/add-to-watchlist-modal.actions';
// services
import { WatchlistsService } from 'WatchlistApp/ts/services/watchlists.service';
// Constants
import { ADD_TO_WATCHLIST_STATE_SLICE_KEY } from 'WatchlistApp/ts/features/add-to-watchlist-modal/state/add-to-watchlist-modal.reducer';
import { ERROR_MESSAGE_DICT } from 'WatchlistApp/ts/features/add-to-watchlist-modal/state/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
import * as i2 from "WatchlistApp/ts/services/watchlists.service";
import * as i3 from "@ngrx/store";
/**
 *
 * Watchlist field item Component
 *
 * This component is responsible for allowing users to create a new watchlist directly within the add-to-watchlist modal.
 *
 * * Input Properties
 * securityObject: an object that contains serialize Security info on the backend.
 */
export class CreateWatchlistFieldItemComponent {
    constructor(formBuilder, watchlistsService, store) {
        this.formBuilder = formBuilder;
        this.watchlistsService = watchlistsService;
        this.store = store;
        this.WATCHLIST_NAME_MAX_LENGTH = 50;
        this.watchlistForm = this.formBuilder.group({
            watchlistName: '',
        });
        this.mapStateToComponent = (state) => {
            this.securityObject = state.securityObject;
        };
        this.storeSubscription = this.store
            .select(ADD_TO_WATCHLIST_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    createNewWatchlist() {
        const { securityObject, watchlistForm } = this;
        if (!watchlistForm.value.watchlistName) {
            return;
        }
        this.watchlistsService
            .postWatchlist(securityObject.watchlist_type, watchlistForm.value.watchlistName, [
            securityObject.security_id,
        ])
            .subscribe({
            next: (data) => {
                this.store.dispatch(createWatchlist({ watchlist: data.watchlist }));
                this.store.dispatch(removeWatchlistItemError());
            },
            error: () => {
                this.store.dispatch(setWatchlistItemError({ errorMessage: ERROR_MESSAGE_DICT.INVALID_WATCHLIST_ITEM_CREATE }));
            },
        });
        watchlistForm.reset();
    }
}
CreateWatchlistFieldItemComponent.ɵfac = function CreateWatchlistFieldItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CreateWatchlistFieldItemComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.WatchlistsService), i0.ɵɵdirectiveInject(i3.Store)); };
CreateWatchlistFieldItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CreateWatchlistFieldItemComponent, selectors: [["ycn-create-watchlist-field-item"]], inputs: { securityObject: "securityObject" }, standalone: false, decls: 8, vars: 2, consts: [[1, "mb-1"], [1, "form-label", "form-label-thin"], [1, "mb-row"], [1, "input-group", "col", 3, "ngSubmit", "formGroup"], ["formControlName", "watchlistName", "type", "text", "placeholder", "Enter a name...", 1, "form-control", 3, "maxlength"], [1, "input-group-btn"], ["type", "submit", "value", "Create", 1, "btn", "btn-secondary"]], template: function CreateWatchlistFieldItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtext(2, "Add to a new Watchlist:");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(3, "div", 2)(4, "form", 3);
        i0.ɵɵlistener("ngSubmit", function CreateWatchlistFieldItemComponent_Template_form_ngSubmit_4_listener() { return ctx.createNewWatchlist(); });
        i0.ɵɵelement(5, "input", 4);
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelement(7, "input", 6);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("formGroup", ctx.watchlistForm);
        i0.ɵɵadvance();
        i0.ɵɵproperty("maxlength", ctx.WATCHLIST_NAME_MAX_LENGTH);
    } }, dependencies: [i1.ɵNgNoValidate, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.MaxLengthValidator, i1.FormGroupDirective, i1.FormControlName], encapsulation: 2 });
